import { deliveryEstimateFromStore, type DeliveryEstimate } from "@/lib/helpers/delivery"
import { toPriceView, type PriceView } from "@/lib/money/price-view"
import type { StoreProduct } from "@/platform/api/store-contract"

export interface CartProduct {
  id: string
  title: string
  handle: string
  price: PriceView
  variantId: string
  variantLabel?: string
  thumbnail?: string
  inStock: boolean
  delivery?: DeliveryEstimate
}

export const cartProductDetails = (product: StoreProduct, variantId: string): CartProduct | null => {
  const variant = product.variants.find((candidate) => candidate.id === variantId)
  if (!variant) return null
  const price = toPriceView(variant.price)
  if (!price) throw new Error("Cart product requires a resolved price")

  return {
    id: product.id,
    title: product.title ?? "",
    handle: product.handle ?? "",
    thumbnail: product.thumbnail ?? undefined,
    variantId,
    variantLabel: product.variants.length > 1 && variant.title ? variant.title : undefined,
    price,
    inStock: Boolean((variant.inventory_quantity ?? 0) > 0 || variant.allow_backorder),
    delivery: deliveryEstimateFromStore(product.store),
  }
}
